// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentfulEducationalComponent_container__gIGK8","itemsContainer":"ContentfulEducationalComponent_itemsContainer__IMkyy"};